<template>

  <a-select :show-search='showSearch'
          :allowClear='allowClear'
          :filter-option='filterOption'
          :placeholder="placeholder"
          :disabled="disabled"
          :value="value"
          :getPopupContainer="getPopupContainer"
           :mode="mode"
          @change="handleInput">
      <a-select-option v-for='(item,k) in  this.dataList' :key="item.value" :value='item.value' :label='item.text' :disabled="disabledChange(item.value)">
        {{ item.text }}
      </a-select-option>
  </a-select>




</template>

<script>
import {  getDictItemsFromCache } from '@/api/api'
import store from '@/store/'
  export default {
    name: "FSelectDictCache",
    props: {
      placeholder: String,
      disabled: Boolean,
      showSearch:{
        type:Boolean,
        required: false,
        default: false,
      },
      filterOption:{
        type:Function,
        required: false,
        default: (input, option)=>option.componentOptions.propsData.label.toLocaleString().indexOf(input.toLocaleString())>=0,
      },
      value: [String, Number],
      allowClear:Boolean,
      getPopupContainer:{
        type: Function,
        default: () => document.body
      },
      dict: String,
      mode:String,
      hiddenItem:Array,
      disabledItem:Array
    },
    data() {
      return {
        dataList:[]
      }
    },
    watch:{
    },
    created() {
      this.dataList=getDictItemsFromCache(this.dict);
      if(this.hiddenItem&&this.hiddenItem.length>0){
        this.dataList=this.dataList.filter(item=>!this.hiddenItem.includes(item.value));
      }
      this.changelangText();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      disabledChange(value){
        if(this.disabledItem){
         let ob= this.disabledItem.find(item=>item===value);
         if(ob){
           return true;
         }
        }
        return false;

      },
      handleInput(e='') {
        let val;
        if(Object.keys(e).includes('target')){
          val = e.target.value
        }else{
          val = e
        }
        this.$emit('change', val);
      },
      /**
       * 多语言支持
       */
      changelangText() {
        if(this.dataList){
            for (let dictItem of this.dataList) {
              let dictText="";
                if(dictItem.langKey != null && dictItem.langKey !== '' && dictItem.langKey !== undefined){
                  let language = store.getters.language;
                  dictText = language[dictItem.langKey];//language['Multilingual.columns.key'];
                } else {
                  dictText = (dictItem.text || dictItem.title || dictItem.label)
                }
              dictItem.text=dictText;
            }
        }
          }
      }
    ,
    model:{
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style scoped>
</style>